import type { PviGraphWithSpans } from '../../editor/pviTypes';
import { SCENARIO_CATEGORIES, type ScenarioCategory } from '../../editor/adversarialEngine';
import { useAdversarialStore } from '../../stores/useAdversarialStore';
import styles from './Adversarial.module.css';

interface ScenarioSelectorProps {
  graph: PviGraphWithSpans;
}

export function ScenarioSelector({ graph }: ScenarioSelectorProps) {
  const result = useAdversarialStore(s => s.result);
  const running = useAdversarialStore(s => s.running);
  const selectedScenario = useAdversarialStore(s => s.selectedScenario);
  const runAll = useAdversarialStore(s => s.runAll);
  const runCategory = useAdversarialStore(s => s.runCategory);
  const selectScenario = useAdversarialStore(s => s.selectScenario);

  return (
    <div>
      {/* Controls */}
      <div className={styles.advControls}>
        <button
          className={styles.btnRunAll}
          onClick={() => runAll(graph)}
          disabled={running}
        >
          {running ? <span className={styles.spinner} /> : 'Run All Scenarios'}
        </button>
      </div>

      {/* Scenario list */}
      <ul className={styles.scenarioList}>
        {SCENARIO_CATEGORIES.map(cat => {
          const scenResult = result?.scenarios.find(s => s.category === cat.id);
          const isSelected = selectedScenario === cat.id;

          return (
            <li
              key={cat.id}
              className={`${styles.scenarioItem} ${isSelected ? styles.scenarioItemSelected : ''}`}
              onClick={() => selectScenario(isSelected ? null : cat.id)}
            >
              <div>
                <div className={styles.scenarioLabel}>{cat.label}</div>
                <div className={styles.scenarioDesc}>{cat.description}</div>
              </div>
              <div className={styles.scenarioStats}>
                {scenResult ? (
                  <>
                    <span className={styles.statRuns}>{scenResult.totalRuns} runs</span>
                    {scenResult.totalFailures > 0 ? (
                      <span className={styles.statFails}>{scenResult.totalFailures} fail</span>
                    ) : (
                      <span className={styles.statPass}>pass</span>
                    )}
                  </>
                ) : (
                  <button
                    className={styles.btnRunCategory}
                    onClick={(e) => {
                      e.stopPropagation();
                      runCategory(graph, cat.id as ScenarioCategory);
                    }}
                    disabled={running}
                  >
                    Run
                  </button>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
